import React, { useEffect, useId, useRef } from 'react'
import classNames from 'classnames'

const styles = {
  modal: {
    display: 'block'
  }
}

const Modal = ({
  headerText, headerContent, children, footerContent, widen, medium, centered, footerClassName, onClose = () => {}
}) => {
  const titleId = useId()
  const dialogRef = useRef(null)

  // Move focus into the dialog so it is announced and the keyboard leaves the page behind it, and
  // hand it back to whatever opened it. A field the content autofocuses keeps its focus.
  useEffect(() => {
    const opener = document.activeElement
    if (!dialogRef.current.contains(document.activeElement)) dialogRef.current.focus()

    return () => opener?.focus?.()
  }, [])

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEscapeKey)
    return () => document.removeEventListener('keydown', handleEscapeKey)
  }, [onClose])

  const modalClass = classNames({
    'modal-dialog': true,
    'modal-lg': widen,
    'modal-md': medium,
    'modal-dialog-centered': centered
  })

  return (
    <div className='modal-open'>
      <div className='modal-backdrop show' />
      <div
        className='modal'
        style={styles.modal}
        onClick={onClose}
        ref={dialogRef}
        role='dialog'
        aria-modal='true'
        aria-labelledby={headerText ? titleId : undefined}
        tabIndex={-1}
      >
        <div className={modalClass} onClick={(e) => e.stopPropagation()}>
          <div className='modal-content'>
            <div className='modal-header'>
              {headerText && <h5 className='modal-title' id={titleId}>{headerText}</h5>}
              {headerContent}
              <button type="button" className='btn-close' aria-label='Close' onClick={onClose}>
              </button>
            </div>
            <div className='modal-body'>
              {children}
            </div>
            {footerContent && <div className={`modal-footer ${footerClassName}`}>{footerContent}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
